import { Button, Card, CardContent, Input, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import PerfectScrollbar from 'react-perfect-scrollbar';
import api from '../../../services/api';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class TipoVeiculoList extends Component {
    state = {
        tiposveiculos: [],
        searchFilter: {
            nomeTipoVeiculo: '',
            situacaoInativoFilter: ANAO,
        },
    };

    estilo = {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        container: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            float: 'right', // alinhamento a direita
            marginTop: 3,
            marginRight: 3
        },
        redText: {
            color: 'red',
        },
    };

    constructor(props) {
        super(props);
    }

    /* carregamento inicial */
    async componentDidMount() {
        this.loadTiposVeiculo();
    }

    /* carrega tipos veículo */
    loadTiposVeiculo = async () => {
        const { searchFilter } = this.state;
        let params = '';
        params += '?sort=tbtipoveiculo.codtipoveiculo'

        try {
            const response = await api.get('/tipoveiculo' + params);
            console.log(' DADOS RETORNADOS DO BACKEND:', response.data); // Log para debug
            this.setState({ tiposveiculos: response.data });
        } catch (error) {
            console.error('Erro ao carregar tipos de veículos:', error);
        }
    };

    /* escolha de um registro para exclusão */
    handleSelectItem = (id) => {
        this.setState({ selectedId: id });
    };

    /* deleta tipo veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/tipoveiculo/${id}`);
            // Verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadTiposVeiculo();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
            console.log(error);
            console.log(error.message);
        }
    };

    /* abre janela confirmação para exclusão */
    handleOpen = (codtipoveiculo) => {
        this.setState({ open: true });
        this.handleSelectItem(codtipoveiculo);
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { searchFilter } = this.state;
        let { name, value } = event.target;
        value = value.toUpperCase()
        searchFilter[name] = value;
        this.setState({ searchFilter: searchFilter });
        if (name === 'situacaoInativoFilter') {
            this.loadTiposVeiculo();
        }
    };

    /* limpa Filtros na tela */
    LimpaFiltros = () => {
        let { searchFilter } = this.state;
        searchFilter.nomeTipoVeiculo = '';
        searchFilter.situacaoInativoFilter = 'N';
        this.setState({ searchFilter: searchFilter });
    }

    render() {
        const { tiposveiculos } = this.state;
        const { searchFilter } = this.state;
        return (
            <div style={this.estilo}>
                <Button
                    component={Link}
                    to="/frotas/tipoveiculo/novo"
                    variant="contained"
                    color="primary"
                    style={this.estilo.addButton}
                >
                    Novo
                </Button>

                <Paper hover>
                    <Input
                        autoFocus
                        id="nomeTipoVeiculo"
                        name="nomeTipoVeiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.OnChangeSearch}
                        placeholder="Nome tipo veículo a pesquisar"
                        style={{ marginBottom: 10, width: 300, marginLeft: 10, marginTop: 10 }}
                        value={searchFilter.nomeTipoVeiculo}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        style={{ marginLeft: 20 }}
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.OnChangeSearch}
                    >
                        <MenuItem value={ANAO}>Ativos</MenuItem>
                        <MenuItem value={ASIM}>Inativos</MenuItem>
                        <MenuItem value={'T'}>Todos</MenuItem>
                    </Select>

                    <Button
                        color="primary"
                        id="pesquisar"
                        onClick={() => this.loadTiposVeiculo()}
                    >
                        <SearchIcon />
                    </Button>

                    <Button
                        color="primary"
                        onClick={() => this.LimpaFiltros()}
                    >
                        <ClearAllIcon />
                    </Button>
                </Paper>

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Descrição</TableCell>
                                            <TableCell>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tiposveiculos.slice(0, 100).map(tipoveiculo => (
                                            <TableRow
                                                hover
                                                key={tipoveiculo.codtipoveiculo}
                                            >
                                                <TableCell style={(tipoveiculo.inativo === ASIM) ? this.estilo.redText : {}}>{tipoveiculo.codtipoveiculo}</TableCell>

                                                <TableCell style={(tipoveiculo.inativo === ASIM) ? this.estilo.redText : {}} >{tipoveiculo.desctipoveiculo}</TableCell>

                                                <TableCell>
                                                    <Link to={`/frotas/tipoveiculo/${tipoveiculo.codtipoveiculo}`}>
                                                        <EditOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <Link to={`/frotas/tipoveiculo/${tipoveiculo.codtipoveiculo}/view`}>
                                                        <PageviewOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <DeleteForeverOutlinedIcon
                                                        onClick={() => this.handleOpen(tipoveiculo.codtipoveiculo)}
                                                        style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={this.state.open}
                    handleClose={() => this.handleClose()}
                    itemId={this.state.selectedId}
                    message={"Confirma exclusão do tipo de veículo " + this.state.selectedId + '?'}
                    handleDelete={() => this.handleDelete(this.state.selectedId)}
                />

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div>
        );
    }
}

export default TipoVeiculoList;